

import { ref, computed } from 'vue'
import { useToast } from "primevue/usetoast";
import AuthRepository from "@/services/AuthRepository";
import { User } from '@/models/user.models';
import router from '@/router';
import { useConfirm } from "primevue/useconfirm";
import {useStore} from "vuex";
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";

export default {
  props: {
    id: Number,
  },
  setup(props){
    const toast = useToast();
    const updateUser = ref({} as User);
    const valid = computed(()=> (updateUser.value.fullname == "") || (updateUser.value.username == ""));
    const confirm = useConfirm();
    const store = useStore();
    const teams = ref({} as Team[]);

      TeamRepository.getTeams()
          .then((response) => {
              teams.value = response.data;
          })
          .catch();

      if(!(store.state.permission == 'admin')){
          router.push({
              name: 'home'
          });
      }

      const userPermission = ref([
          { label: 'Nhân viên', value: 'user' },
          { label: 'Quản lý', value: 'admin' },
      ]);

      AuthRepository.getById(props.id)
          .then(response => {
              updateUser.value = response.data;
              updateUser.value.password = "";
          })
          .catch(() => {
              toast.add({
                  severity: 'error',
                  summary: 'Thất bại',
                  detail: 'Không thể tải thông tin tài khoản.',
                  life: 1000
              });
          })
          .finally(() => {
          });
      const del = (event) => {
          confirm.require({
              target: event.currentTarget,
              message: 'Bạn có chắc muốn xoá tài khoản này không?',
              icon: 'pi pi-info-circle',
              acceptClass: 'p-button-danger',
              rejectClass: 'p-button-outlined',
              acceptLabel: 'Đồng ý',
              rejectLabel: 'Huỷ',
              accept: () => {
                  AuthRepository.delete(updateUser.value.id)
                      .then(response => {
                          toast.add({severity:'info', summary:'Confirmed', detail:'Tài khoản đã được xoá thành công', life: 3000});
                          router.push({
                              name: 'home',
                          });
                      })
                      .finally(()=>{
                      });
              },
              reject: () => {
              }
          });
      };

      const update = () => {
        if(updateUser.value.password.length < 6)
        {
            toast.add({
                severity: 'error',
                summary: 'Thất bại',
                detail: 'Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu',
                life: 2000
            });
        }
        else
        {
            AuthRepository.update(updateUser.value)
                .then(response => {
                    toast.add({
                        severity: 'success',
                        summary: 'Thành Công',
                        detail: 'Cập nhật thông tin nhân viên thành công.',
                        life: 2500
                    });
                    router.push({
                        name: 'home',
                    });
                })
                .catch(err => {
                    toast.add({
                        severity: 'error',
                        summary: 'Lỗi',
                        detail:err.response.data,
                        life: 2500
                    });
                })
                .finally(()=>{
                });
        }
      };

    return {
      updateUser,
      teams,
      userPermission,
      update,
      del,
      valid,
    }
  }
}

